export enum ConsumptionTypes {
    Spend = 'spend',
    Energy = 'energy',
    None = 'none'
}
